import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SortingArrowUpIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                id="Vector"
                d="M10.0002 15.8334L10.0002 4.16671"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                id="Vector_2"
                d="M4.16683 10.0001L10.0002 4.16673L15.8335 10.0001"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
